import { useEffect, useMemo, useState } from "react";
import { post } from "../js/post";
import "../css/OptometryScreen.css";
import "../css/Glasses.css";
import moment from "moment";
import {
  contactLensRecordStructure,
  inputOnEnter,
  userData,
  selectedOptic,
  areObjectsEqual,
  focusElement,
  contactLensesUseOptions,
  checkOfferPrice,
  calculateDiscountFromTotal,
  calculateTotalLens,
  calculateAddFromTotal,
  formatValueUnit,
} from "../js/utils";
import { contactLensesTestListColumns } from "../js/tableColumns";
import InputData from "./InputData";
import InputDataControl from "../support-extra/components/InputDataControl";
import InputIconSearch from "./InputIconSearch";
import DropdownFilter from "./DropdownFilter";
import Dropdown from "./Dropdown";
import ButtonIconV from "./ButtonIconV";
import CheckBox from "./CheckBox";
import RadioButton from "./RadioButton";
import ButtonIconH from "./ButtonIconH";
import SummarySectionBox from "./SummarySectionBox";
import ActionPopup from "./ActionPopup";
import Insurance from "./Insurance";
import HealthData from "../support-extra/components/HealthData";
import ObservationsPanel from "./ObservationsPanel";
import AssociateProduct from "./AssociateProduct";
import DataTable from "react-data-table-component";
import ContactLensesTest from "./ContactLensesTest";
import LoadingScreen from "./LoadingScreen";
import SalesManagement from "./SalesManagement";
import { calculateDtos } from "../js/calculateDtos";
import { getPatientProductPrice } from "../js/patientProductPrice";
import { useAgents } from "../hooks/useAgents";
import { useSuppliers } from "../hooks/useSuppliers";
import { useBrands } from "../hooks/useBrands";
import { useCampaigns } from "../hooks/useCampaigns";
import { useObservations } from "../hooks/useObservations";
import { useModelsTradeNamesAndProducts } from "../hooks/useModelsTradeNamesAndProducts";
import { ContactLensesReportPopup } from "./ContactLensesReportPopup";
import PopupCGCOOLentesContacto from "../support-extra/components/PopupCGCOOLentesContacto";

export default function ContactLenses({
  patientInfo,
  id,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
  onClickMenuOption,
}) {
  const [actionPopup, setActionPopup] = useState(null);
  const [dateHistoryList, setDateHistoryList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({ id: "", text: "" });
  const [contactLensesId, setContactLensesId] = useState(id);
  const [currentContactLenses, setCurrentContactLenses] = useState(
    contactLensRecordStructure,
  );
  const [currentContactLensesEdit, setCurrentContactLensesEdit] = useState(
    contactLensRecordStructure,
  );
  const agentList = [{ id: "", text: "" }, ...useAgents()];
  const reasonList = [{ id: "", text: "" }, ...useCampaigns()];
  const [recordTypeList, setRecordTypeList] = useState([]);
  const [CLTypeList, setCLTypeList] = useState([]);
  const [insurance, setInsurance] = useState({});
  const { list: observations, refresh: refreshObservations } = useObservations(
    currentContactLensesEdit.idFicha,
    "Ficha",
  );
  const [healthData, setHealthData] = useState([]);
  const [actionComponent, setActionComponent] = useState(null);
  const [CLTest, setCLTest] = useState(false);
  const [selectedCLTest, setSelectedCLTest] = useState(-1);
  const [toggleObservationPanel, setToggleObservationPanel] = useState(false);
  const CLFullSupplierList = useSuppliers(2)[0];
  const CLSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...CLFullSupplierList.map((e) => ({
        id: e.id,
        text: e.nombre,
      })),
    ],
    [CLFullSupplierList],
  );
  const liquidFullSupplierList = useSuppliers(3)[0];
  const liquidSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...liquidFullSupplierList.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [liquidFullSupplierList],
  );
  const [selectedLiquidSupplier, setSelectedLiquidSupplier] = useState({
    id: -1,
    text: "",
  });
  const [selectedLeftCLSupplier, setSelectedLeftCLSupplier] = useState({
    id: -1,
    text: "",
  });
  const [selectedRightCLSupplier, setSelectedRightCLSupplier] = useState({
    id: -1,
    text: "",
  });
  const rawLiquidBrandList = useBrands(3, selectedLiquidSupplier.id)[0];
  const liquidBrandList = useMemo(() => {
    const brands = rawLiquidBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawLiquidBrandList]);

  const rawLeftCLBrandList = useBrands(2, selectedLeftCLSupplier.id)[0];
  const leftCLBrandList = useMemo(() => {
    const brands = rawLeftCLBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawLeftCLBrandList]);

  const rawRightCLBrandList = useBrands(2, selectedRightCLSupplier.id)[0];
  const rightCLBrandList = useMemo(() => {
    const brands = rawRightCLBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawRightCLBrandList]);

  const rawRightCLModelsList = useModelsTradeNamesAndProducts(
    [2],
    selectedRightCLSupplier.id,
    [currentContactLensesEdit.datosLentillaOD.marca],
  )[0];
  const rightCLModelsList = useMemo(() => {
    const models = rawRightCLModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawRightCLModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawRightCLModelsList]);

  const rawLeftCLModelsList = useModelsTradeNamesAndProducts(
    [2],
    selectedLeftCLSupplier.id,
    [currentContactLensesEdit.datosLentillaOI.marca],
  )[0];
  const leftCLModelsList = useMemo(() => {
    const models = rawLeftCLModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawLeftCLModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawLeftCLModelsList]);

  const rawLiquidModelsList = useModelsTradeNamesAndProducts(
    [3],
    selectedLiquidSupplier.id,
    [currentContactLensesEdit.liquido.marca],
  )[0];
  const liquidModelsList = useMemo(() => {
    const models = rawLiquidModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawLiquidModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawLiquidModelsList]);

  const [selectAll, setSelectAll] = useState(false);
  const [CLTestList, setCLTestList] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [total, setTotal] = useState(0);
  const [originalPrices, setOriginalPrices] = useState({
    datosLentillaOD: null,
    datosLentillaOI: null,
    liquido: null,
  });
  const [reportPopup, setReportPopup] = useState(false);
  const [CGCOOPopup, setCGCOOPopup] = useState(false);

  // console.log("currentContactLensesEdit: ", currentContactLensesEdit);
  // console.log("selectedRightCLSupplier: ", selectedRightCLSupplier);
  // console.log("CLSupplierList: ", CLSupplierList);

  const getRecordTypeList = async () => {
    let response = await post("/support-extra/fichas/ListarTipoFichas.php", {
      token: userData.token,
      familia: 2,
    });
    setRecordTypeList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.codigo, text: e.descripcion })),
    ]);
  };

  const getLensesTypeList = async () => {
    const response = await post("ListarTiposLenteContacto.php", {
      token: userData.token,
    });
    setCLTypeList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.descripcion, text: e.descripcion })),
    ]);
  };

  const getInsurance = async () => {
    const response = await post("/support-extra/fichas/ObtenerSeguro.php", {
      token: userData.token,
      idFicha: currentContactLensesEdit.idFicha,
    });
    setInsurance(response);
  };

  const getHealthData = async () => {
    const response = await post("ListarDatosSanitarios.php", {
      token: userData.token,
      idPaciente: patientInfo.id,
      optica: selectedOptic.id,
      codigos: [
        currentContactLensesEdit.datosLentillaOD.codigo,
        currentContactLensesEdit.datosLentillaOI.codigo,
        currentContactLensesEdit.liquido.codigo,
      ],
    });
    setHealthData(response);
  };

  const getCLHistory = async () => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaLentillas.php",
      {
        token: userData.token,
        idPaciente: patientInfo.id,
        completo: 1,
      },
    );
    if (response.length > 0) {
      const found = response.find((e) => {
        return e.idFichaLentillas === contactLensesId;
      });
      if (found) {
        setSelectedDate({
          id: found.idFichaLentillas,
          text: found.fecha,
        });
        setContactLensesId(found.idFichaLentillas);
      }
    }
    setDateHistoryList(response);
  };

  const getCLTestHistory = async () => {
    const response = await post(
      "/support-extra/fichas/ListarFichaLentillasPruebas.php",
      {
        token: userData.token,
        idFichaLentillas: contactLensesId,
        todas: selectAll ? 1 : 0,
      },
    );

    if (!Array.isArray(response) || response.length === 0) {
      setCLTestList([]);
      return;
    }

    const formatEntry = (eye, data) => ({
      ojo: eye,
      ficha: data.idFichaLentillas,
      idFichaLentillasPruebas: data.idFichaLentillasPruebas,
      fecha: data.fecha,
      nombreComercial: data[eye].nombreComercial,
      rad: data[eye].rad,
      rad2: data[eye].rad2,
      dia: data[eye].dia,
      cil: data[eye].cil,
      eje: data[eye].eje,
      esf: data[eye].esf,
      add: data[eye].add,
      observacionesPruebas: data[eye].observaciones,
    });

    const list = response.flatMap((e) => [
      formatEntry("OD", e),
      formatEntry("OI", e),
    ]);

    setCLTestList(list);
  };

  const resetCLState = () => {
    setCurrentContactLenses({
      ...contactLensRecordStructure,
      fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setCurrentContactLensesEdit({
      ...contactLensRecordStructure,
      fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setContactLensesId(-1);
    setSelectedDate({
      id: -1,
      text: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setSelectedLiquidSupplier({ id: -1, text: "" });
    setSelectedRightCLSupplier({ id: -1, text: "" });
    setSelectedLeftCLSupplier({ id: -1, text: "" });
  };

  function showNotProductFoundMessage(code, index) {
    createPopupQuestion(
      `No existe ningún producto con el código ${code}.`,
      () => {
        removePopupQuestion();
        focusElement(index);
      },
      null,
      "Entendido",
    );
  }

  function checkSaved() {
    createPopupQuestion(
      `Por favor, guarde la ficha primero.`,
      () => {
        removePopupQuestion();
      },
      null,
      "Entendido",
    );
  }

  const getProductPrice = (product) =>
    getPatientProductPrice({
      product,
      idPaciente: patientInfo?.id,
      createPopupQuestion,
      removePopupQuestion,
    });

  const searchCLByCode = async (side, code) => {
    const lensKey = side === 0 ? "datosLentillaOD" : "datosLentillaOI";
    let codigo = code || currentContactLensesEdit[lensKey].codigo;

    codigo = !codigo || codigo === "0" ? "20" : codigo;

    const CLResponse = await fetchContactLensData(codigo);

    if (!CLResponse?.id) {
      const index = side === 0 ? 61 : 84;
      showNotProductFoundMessage(codigo, index);
      return;
    }

    const nextIndex =
      side === 0 ? (codigo === "20" ? 62 : 84) : codigo === "20" ? 85 : 107;
    setTimeout(() => {
      focusElement(nextIndex);
    }, 100);

    const price = await getProductPrice(CLResponse);

    const updatedLensData = mapCLData(
      currentContactLensesEdit[lensKey],
      CLResponse,
      price,
    );
    setCurrentContactLensesEdit((prev) => ({
      ...prev,
      [lensKey]: updatedLensData,
    }));
    setOriginalPrices((prev) => ({
      ...prev,
      [lensKey]: CLResponse.pvp,
    }));
  };

  const fetchContactLensData = async (codigo) => {
    const payload = {
      token: userData.token,
      codigo,
      tipoCodigo: -1,
      idOptica: selectedOptic.id,
    };
    const response = await post("ObtenerLenteContacto.php", payload);
    return response;
  };

  const mapCLData = (currentCLData, response, price) => ({
    ...currentCLData,
    add: response.add,
    ao: "",
    avcc: 0,
    cil: response.cil,
    codigo: response.codigoOPTIWIN,
    color: response.color,
    descuento: price.descuento,
    desechable: response.desechable,
    dia: response.dia,
    eje: response.eje,
    esf: response.esf,
    marca: response.marca,
    nombreComercial: response.nombreComercial,
    pack: 1,
    proveedor: response.nombreProveedor,
    idProveedor: response.idProveedor,
    pvp: price.pvp,
    rad: response.rad1,
    rad2: response.rad2,
    tipo: response.tipo,
    total: response.total,
    totalPrecio: calculateSectionTotal(price.pvp, price.descuento, 1),
    unidades: response.unidades,
    uso: response.uso,
    dtoMaximo: response.dtoMaximo,
    unidadesPvpEspecial: response.unidadesPvpEspecial,
    pvpEspecial: response.pvpEspecial,
    fechaOfertaInicio: response.fechaOfertaInicio,
    fechaOfertaFin: response.fechaOfertaFin,
    pvpOferta: response.pvpOferta,
    pvpOriginal: response.pvp,
  });

  const searchLiquidByCode = async (code) => {
    let codigo = code || currentContactLensesEdit.liquido.codigo;
    codigo = !codigo || codigo === "0" ? "30" : codigo;

    if (!codigo) return;

    const payload = {
      token: userData.token,
      codigo,
      tipoCodigo: -1,
      idOptica: selectedOptic.id,
    };
    const response = await post("ObtenerLiquido.php", payload);

    if (!response?.id) {
      const index = 107;
      showNotProductFoundMessage(codigo, index);
      return;
    }

    const price = await getProductPrice(response);

    setCurrentContactLensesEdit((prev) => ({
      ...prev,
      liquido: {
        ...prev.liquido,
        capacidad: response.capacidad,
        codigo: response.codigoOPTIWIN,
        descuento: price.descuento,
        marca: response.marca,
        nombreComercial: response.nombreComercial,
        nombreProveedor: response.nombreProveedor,
        idProveedor: response.idProveedor,
        pack: 1,
        pvp: price.pvp,
        total: calculateSectionTotal(price.pvp, price.descuento, 1),
        dtoMaximo: response.dtoMaximo,
        unidadesPvpEspecial: response.unidadesPvpEspecial,
        pvpEspecial: response.pvpEspecial,
        fechaOfertaInicio: response.fechaOfertaInicio,
        fechaOfertaFin: response.fechaOfertaFin,
        pvpOferta: response.pvpOferta,
        pvpOriginal: response.pvp,
      },
    }));
    setOriginalPrices((prev) => ({
      ...prev,
      liquido: response.pvp,
    }));
    setTimeout(() => {
      focusElement(codigo === "30" ? 108 : 116);
    }, 100);
  };

  const getContactLenses = async (id) => {
    const response = await post(
      "/support-extra/fichas/ObtenerFichaLentillas.php",
      {
        token: userData.token,
        idFichaLentillas: id,
        idOptica: selectedOptic.id,
      },
    );

    setCurrentContactLenses({
      ...response,
      idPaciente: patientInfo.id,
      idFichaLentillas: id,
    });
    setCurrentContactLensesEdit({
      ...response,
      idPaciente: patientInfo.id,
      idFichaLentillas: id,
    });
    setOriginalPrices({
      datosLentillaOD: response.datosLentillaOD.pvpOriginal,
      datosLentillaOI: response.datosLentillaOI.pvpOriginal,
      liquido: response.liquido.pvpOriginal,
    });
  };

  const cloneCL = async () => {
    const response = await post(
      "/support-extra/fichas/ClonarFichaLentillas.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idFichaLentillas: contactLensesId,
      },
    );
    setContactLensesId(parseInt(response.idFichaLentillas));
  };

  const cancelChanges = async () => {
    if (dateHistoryList.length > 0) {
      // 1. Si estamos creando una ficha, cargamos la última.
      if (contactLensesId === -1) {
        setSelectedDate({
          id: dateHistoryList[0].idFichaLentillas,
          text: dateHistoryList[0].fecha,
        });
        setContactLensesId(dateHistoryList[0].idFichaLentillas);
        await getContactLenses(dateHistoryList[0].idFichaLentillas);
      } else {
        // 2. Si estamos viendo una ficha, cancelamos los cambios.
        setCurrentContactLensesEdit(currentContactLenses);
      }
    } else {
      setCurrentContactLensesEdit(currentContactLenses);
    }
  };

  const deleteCL = async () => {
    await post("/support-extra/fichas/EliminarFichaLentillas.php", {
      token: userData.token,
      idFichaLentillas: contactLensesId,
      idUsuario: userData.id,
    });
  };

  const selectCLAfterDeleting = async () => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaLentillas.php",
      {
        token: userData.token,
        idPaciente: patientInfo.id,
        completo: 1,
      },
    );
    if (response.length > 0) {
      setSelectedDate({
        id: response[0].idFichaLentillas,
        text: response[0].fecha,
      });
      setContactLensesId(response[0].idFichaLentillas);
      setDateHistoryList(response);
      await getContactLenses(response[0].idFichaLentillas);
    } else {
      setSelectedDate({
        id: -1,
        text: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      setContactLensesId(-1);
      setCurrentContactLenses(contactLensRecordStructure);
      setCurrentContactLensesEdit(contactLensRecordStructure);
    }
  };

  const checkDiscount = (contactLensesEdit = currentContactLensesEdit) => {
    const checks = [
      {
        label: "de la lente de contacto derecha",
        data: contactLensesEdit.datosLentillaOD,
        focusId: 71,
      },
      {
        label: "de la lente de contacto izquierda",
        data: contactLensesEdit.datosLentillaOI,
        focusId: 94,
      },
      {
        label: "del líquido",
        data: contactLensesEdit.liquido,
        focusId: 113,
      },
    ];

    for (const { label, data, focusId } of checks) {
      if (data.dtoMaximo !== "" && data.descuento > data.dtoMaximo) {
        createPopupQuestion(
          `El descuento ${label} no puede ser mayor que su descuento máximo (${data.dtoMaximo}%).`,
          () => {
            removePopupQuestion();
            focusElement(focusId);
          },
          null,
          "Entendido",
        );
        return false;
      }
    }
    return true;
  };

  // Descuentos y precios se guardan como float con todos sus decimales (también
  // al enviarlos y recibirlos de los endpoints), pero los inputs los muestran
  // redondeados: el DTO a entero y los precios a céntimos. Por eso los inputs
  // no escriben en el estado al teclear, y al salir solo se recalcula si el
  // usuario ha cambiado el valor visible. El total de cada sección se guarda
  // en "totalPrecio" (lentes) o "total" (líquido) e incluye el pack.
  const roundDto = (dto) => Math.round(parseFloat(dto) || 0);

  const roundPrice = (price) =>
    Math.round((parseFloat(price) || 0) * 100) / 100;

  const onBlurPrice = (e, section, totalKey) => {
    const inputValue = Number(e) || 0;
    const sectionData = currentContactLensesEdit[section];
    if (inputValue === roundPrice(sectionData.pvp)) return;

    setCurrentContactLensesEdit({
      ...currentContactLensesEdit,
      [section]: {
        ...sectionData,
        pvp: inputValue,
        [totalKey]: calculateSectionTotal(
          inputValue,
          sectionData.descuento,
          sectionData.pack,
        ),
      },
    });
  };

  const onBlurDiscount = (e, section, totalKey) => {
    const inputValue = Number(e) || 0;
    const sectionData = currentContactLensesEdit[section];
    if (inputValue === roundDto(sectionData.descuento)) return;

    const contactLensesEditN = {
      ...currentContactLensesEdit,
      [section]: { ...sectionData, descuento: inputValue },
    };
    if (!checkDiscount(contactLensesEditN)) {
      setCurrentContactLensesEdit(contactLensesEditN);
      return;
    }
    contactLensesEditN[section][totalKey] = calculateSectionTotal(
      sectionData.pvp,
      inputValue,
      sectionData.pack,
    );
    setCurrentContactLensesEdit(contactLensesEditN);
  };

  const onBlurLineTotal = (e, section, totalKey, focusId) => {
    const sectionData = currentContactLensesEdit[section];
    if (parseFloat(e) === roundPrice(sectionData[totalKey])) return;

    const pvp = parseFloat(sectionData.pvp) || 0;
    if (pvp === 0) {
      const inputValue = Number(e) || 0;
      setCurrentContactLensesEdit((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          descuento: 0,
          pvp: inputValue,
          [totalKey]: inputValue,
        },
      }));
      return;
    }

    const response = calculateDiscountFromTotal({
      pvp,
      total: e,
      dto: parseFloat(sectionData.descuento) || 0,
      pack: sectionData.pack,
      dtoMax: sectionData.dtoMaximo,
      round: false,
    });
    const applyResponse = () =>
      setCurrentContactLensesEdit((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          descuento: response.dto,
          [totalKey]: response.total,
        },
      }));

    if (response.error !== "") {
      focusElement(focusId);
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
          applyResponse();
        },
        null,
        "Entendido",
      );
    } else {
      applyResponse();
    }
  };

  const saveCL = async (onClose = () => {}) => {
    if (!checkDiscount()) return;
    if (validateData()) {
      const totalPrice = calculatePVP();
      const totalDiscount = calculateDiscount();
      const totalTotal = calculateTotal();
      const response = await post(
        "/support-extra/fichas/GuardarFichaLentillas.php",
        {
          token: userData.token,
          idOptica: selectedOptic.id,
          idFichaLentillas: contactLensesId,
          idPaciente: patientInfo.id,
          ...currentContactLensesEdit,
          precioTotal: totalTotal,
          dtoTotal: totalDiscount,
          pvptotal: totalPrice,
        },
      );

      if (!response.idFichaLentillas) return;

      setSelectedDate({
        id: response.idFichaLentillas,
        text: currentContactLensesEdit.fechaCreacion,
      });
      setContactLensesId(response.idFichaLentillas);
      setCurrentContactLensesEdit({
        ...currentContactLensesEdit,
        idFichaLentillas: response.idFichaLentillas,
        idFicha: response.idFicha,
        precioTotal: totalTotal,
        dtoTotal: totalDiscount,
        pvptotal: totalPrice,
      });
      setCurrentContactLenses({
        ...currentContactLensesEdit,
        idFichaLentillas: response.idFichaLentillas,
        idFicha: response.idFicha,
        precioTotal: totalTotal,
        dtoTotal: totalDiscount,
        pvptotal: totalPrice,
      });
      createPopupQuestion(
        `Los cambios se han guardado con éxito.`,
        async () => {
          removePopupQuestion();
          setTimeout(() => {
            if (typeof onClose === "function") {
              onClose();
            }
          }, 0);
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) y al menos una marca en alguno de sus apartados antes de guardar la ficha.`,
        async () => {
          removePopupQuestion();
          focusRequiredField();
        },
        null,
        "Entendido",
      );
    }
  };

  const handleOpenActionPopup = (componentType) => {
    switch (componentType) {
      case "insurance":
        setActionComponent({
          name: "Seguro",
          component: (
            <Insurance
              id={currentContactLensesEdit.idFicha}
              onClose={async () => {
                await getInsurance();
                setActionPopup(false);
              }}
            />
          ),
        });
        break;
      case "healthData": {
        const healthDataLines = healthData.map((item) => ({
          id: item.idDatoSanitario,
          line: {
            code: item.codigoArticulo,
            healthControl: {
              date: item.fechaCompra,
              description: item.descripcion,
              deliveryNote: item.nAlbaran,
              shippingNumber: item.nExpedicion,
              lotNumber: item.nLote,
            },
          },
        }));

        setActionComponent({
          name: "Datos sanitarios",
          component: (
            <HealthData
              lines={healthDataLines}
              mode="card"
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={async () => {
                await getHealthData();
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></HealthData>
          ),
        });
        break;
      }
      case "addRightCL":
        setActionComponent({
          name: "Añadir lente de contacto OD",
          component: (
            <AssociateProduct
              famId={2}
              supplier={selectedRightCLSupplier}
              brand={currentContactLensesEdit.datosLentillaOD.marca}
              onSelect={async (e) => {
                await searchCLByCode(0, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addLeftCL":
        setActionComponent({
          name: "Añadir lente de contacto OI",
          component: (
            <AssociateProduct
              famId={2}
              supplier={selectedLeftCLSupplier}
              brand={currentContactLensesEdit.datosLentillaOI.marca}
              onSelect={async (e) => {
                await searchCLByCode(1, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addLiquid":
        setActionComponent({
          name: "Añadir líquido",
          component: (
            <AssociateProduct
              famId={3}
              supplier={selectedLiquidSupplier}
              brand={currentContactLensesEdit.liquido.marca}
              onSelect={async (e) => {
                await searchLiquidByCode(e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "sales":
        setActionComponent({
          name: "Venta · Encargo · Presupuesto · Proforma",
          component: (
            <SalesManagement
              id={currentContactLensesEdit.idFicha}
              patientInfo={patientInfo}
              category={"LC"}
              products={{
                motivo: currentContactLensesEdit.motivoAgente,
                prod1: currentContactLensesEdit.datosLentillaOD,
                prod2: currentContactLensesEdit.datosLentillaOI,
                prod3: {
                  ...currentContactLensesEdit.liquido,
                  totalPrecio: currentContactLensesEdit.liquido.total,
                },
              }}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={() => {
                setActionPopup(false);
                setActionComponent(null);
              }}
              onClickMenuOption={onClickMenuOption}
              onCloseCard={onCloseCard}
            ></SalesManagement>
          ),
        });
        break;
      default:
        setActionComponent(null);
    }
    setActionPopup(true);
  };

  async function reloadACList() {
    switch (actionComponent.name) {
      case "Datos sanitarios":
        await getHealthData();
        break;
      case "Seguro":
        await getInsurance();
        break;
      default:
        break;
    }
  }

  function focusRequiredField() {
    const fields = [
      { value: currentContactLensesEdit.empleado, elementId: 116 },
      { value: currentContactLensesEdit.tipoFicha, elementId: 117 },
      { value: currentContactLensesEdit.datosLentillaOD.marca, elementId: 63 },
      { value: currentContactLensesEdit.datosLentillaOI.marca, elementId: 86 },
      { value: currentContactLensesEdit.liquido.marca, elementId: 109 },
    ];

    const emptyField = fields.find((field) => field.value === "");
    if (emptyField) {
      focusElement(emptyField.elementId);
    }
  }

  function validateData() {
    const fieldsToValidate = [
      currentContactLensesEdit.empleado,
      currentContactLensesEdit.tipoFicha,
    ];

    return (
      fieldsToValidate.every((field) => field !== "") &&
      (currentContactLensesEdit.datosLentillaOD.marca !== "" ||
        currentContactLensesEdit.datosLentillaOI.marca !== "")
    );
  }

  function handleRightOp(op) {
    switch (op) {
      case 1:
        setCurrentContactLensesEdit({
          ...currentContactLensesEdit,
          datosLentillaOI: { ...currentContactLensesEdit.datosLentillaOD },
        });
        break;

      default:
        break;
    }
  }

  function handleLeftOp(op) {
    switch (op) {
      case 1:
        setCurrentContactLensesEdit({
          ...currentContactLensesEdit,
          datosLentillaOD: { ...currentContactLensesEdit.datosLentillaOI },
        });
        break;

      default:
        break;
    }
  }

  // Sin redondear: los precios se guardan como float con todos sus decimales.
  function calculateSectionTotal(pvp, discountPercent, pack) {
    const pvpNum = parseFloat(pvp);
    if (isNaN(pvpNum)) return 0;
    const discount = pvpNum * ((parseFloat(discountPercent) || 0) / 100);
    return (pvpNum - discount) * parseFloat(pack);
  }

  function calculateTotal() {
    const valores = [
      currentContactLensesEdit.datosLentillaOD.totalPrecio,
      currentContactLensesEdit.datosLentillaOI.totalPrecio,
      currentContactLensesEdit.liquido.total,
    ];

    return valores.reduce((acc, val) => {
      const num = parseFloat(val);
      return acc + (isNaN(num) ? 0 : num);
    }, 0);
  }

  function calculatePVP() {
    return (
      parseFloat(currentContactLensesEdit.datosLentillaOD.pvp) +
      parseFloat(currentContactLensesEdit.datosLentillaOI.pvp) +
      parseFloat(currentContactLensesEdit.liquido.pvp)
    );
  }

  function calculateDiscount() {
    const discountLentillaOD =
      parseFloat(
        currentContactLensesEdit.datosLentillaOD.pvp *
          currentContactLensesEdit.datosLentillaOD.pack,
      ) - parseFloat(currentContactLensesEdit.datosLentillaOD.totalPrecio);
    const discountLentillaOI =
      parseFloat(
        currentContactLensesEdit.datosLentillaOI.pvp *
          currentContactLensesEdit.datosLentillaOI.pack,
      ) - parseFloat(currentContactLensesEdit.datosLentillaOI.totalPrecio);
    const discountLiquido =
      parseFloat(
        currentContactLensesEdit.liquido.pvp *
          currentContactLensesEdit.liquido.pack,
      ) - parseFloat(currentContactLensesEdit.liquido.total);
    return discountLentillaOD + discountLentillaOI + discountLiquido;
  }

  async function updateDiscounts(e) {
    let lines = [
      {
        total: currentContactLensesEdit.datosLentillaOD.totalPrecio,
        dto: currentContactLensesEdit.datosLentillaOD.descuento,
        id: currentContactLensesEdit.datosLentillaOD.codigo,
        dtoMax: currentContactLensesEdit.datosLentillaOD.dtoMaximo,
      },
      {
        total: currentContactLensesEdit.datosLentillaOI.totalPrecio,
        dto: currentContactLensesEdit.datosLentillaOI.descuento,
        id: currentContactLensesEdit.datosLentillaOI.codigo,
        dtoMax: currentContactLensesEdit.datosLentillaOI.dtoMaximo,
      },
      {
        total: currentContactLensesEdit.liquido.total,
        dto: currentContactLensesEdit.liquido.descuento,
        id: currentContactLensesEdit.liquido.codigo,
        dtoMax: currentContactLensesEdit.liquido.dtoMaximo,
      },
    ];

    const updatedLines = calculateDtos(lines, e, false, false);

    if (updatedLines.error !== "") {
      createPopupQuestion(
        updatedLines.error,
        () => {
          removePopupQuestion();
          setTotal(calculateTotal());
        },
        null,
        "Entendido",
      );
      return;
    }

    if (validateData()) {
      createPopupQuestion(
        "Se han ajustado los descuentos de forma automática.",
        async () => {
          removePopupQuestion();
          focusElement(61);

          if (updatedLines.lines.length >= 3) {
            setCurrentContactLensesEdit((prev) => ({
              ...prev,
              datosLentillaOD: {
                ...prev.datosLentillaOD,
                descuento: updatedLines.lines[0].dto,
                totalPrecio: updatedLines.lines[0].total,
              },
              datosLentillaOI: {
                ...prev.datosLentillaOI,
                descuento: updatedLines.lines[1].dto,
                totalPrecio: updatedLines.lines[1].total,
              },
              liquido: {
                ...prev.liquido,
                descuento: updatedLines.lines[2].dto,
                total: updatedLines.lines[2].total,
              },
            }));
          }

          setTotal(e);
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) y al menos una marca en alguno de sus apartados y vuelva a establecer el total deseado.`,
        async () => {
          setTotal(calculateTotal());
          removePopupQuestion();
          focusRequiredField();
          return;
        },
        null,
        "Entendido",
      );
    }
  }

  const handlePackPrice = (
    sectionKey,
    quantity,
    currentData,
    setCurrentData,
  ) => {
    const {
      unidadesPvpEspecial,
      pvpEspecial,
      pvpOriginal,
      descuento,
      fechaOfertaInicio,
      fechaOfertaFin,
      pvpOferta,
    } = currentData[sectionKey];

    // Calcular precio por oferta
    const offerPrice = checkOfferPrice({
      fechaOfertaInicio,
      fechaOfertaFin,
      pvpOferta,
      pvp: pvpOriginal || currentData[sectionKey].pvp,
    });

    // Calcular si se aplica precio especial por cantidad
    const useSpecialPrice =
      quantity >= unidadesPvpEspecial && pvpEspecial !== "";
    const finalPvp = useSpecialPrice ? pvpEspecial : offerPrice;

    const total = calculateSectionTotal(finalPvp, descuento, quantity);

    // Clave para el campo del total
    const totalKey = sectionKey === "liquido" ? "total" : "totalPrecio";

    setCurrentData((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        pvp: finalPvp,
        pack: quantity,
        [totalKey]: total,
      },
    }));
  };

  const onCloseCard = () => {
    onClose();
  };

  const CL_GRADUATION_FIELD_LABELS = {
    rad: "Rad",
    dia: "Diá",
    esf: "Esf",
    cil: "Cil",
    eje: "Eje",
    add: "Add",
  };

  const findEmptyLensGraduationField = () => {
    const sections = [
      { data: currentContactLensesEdit.datosLentillaOD, name: "Datos lente de contacto OD" },
      { data: currentContactLensesEdit.datosLentillaOI, name: "Datos lente de contacto OI" },
    ];

    for (const section of sections) {
      for (const field of Object.keys(CL_GRADUATION_FIELD_LABELS)) {
        if (section.data[field] === "") {
          return {
            fieldLabel: CL_GRADUATION_FIELD_LABELS[field],
            sectionName: section.name,
          };
        }
      }
    }
    return null;
  };

  const printFile = async (data) => {
    if (contactLensesId === -1) return;

    const response = await post(
      "/support-extra/gestionDocumental/GenerarFichaLC.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idFichaLentillas: currentContactLensesEdit.idFichaLentillas,
        agente: userData.nombre + " " + userData.apellidos,
        tipoFicha: data.record,
        observaciones: data.observations,
        email: data.email,
      },
    );
    // console.log(
      // "GENERANDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idFichaLentillas: currentContactLensesEdit.idFichaLentillas,
        // agente: userData.nombre + " " + userData.apellidos,
        // tipoFicha: data.record,
        // observaciones: data.observations,
        // email: data.email,
      // },
      // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `ficha_lc.pdf`;
      a.click();
    }
  };

  useEffect(() => {
    async function initData() {
      focusElement(61);
      await getCLHistory();
      await getRecordTypeList();
      await getLensesTypeList();

      if (contactLensesId !== -1) {
        await getContactLenses(contactLensesId);
        await getCLTestHistory();
      } else {
        setSelectedDate({
          id: -1,
          text: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        setCurrentContactLensesEdit({
          ...currentContactLensesEdit,
          fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
          idFichaLentillas: -1,
          empleado: userData.nombre + " " + userData.apellidos,
        });
        setCurrentContactLenses({
          ...currentContactLensesEdit,
          fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
          idFichaLentillas: -1,
          empleado: userData.nombre + " " + userData.apellidos,
        });
      }
      setLoadingData(false);
    }
    initData();
  }, [contactLensesId]);

  useEffect(() => {
    getInsurance();
  }, [currentContactLensesEdit.idFicha]);

  useEffect(() => {
    getHealthData();
  }, [
    currentContactLensesEdit.datosLentillaOD.codigo,
    currentContactLensesEdit.datosLentillaOI.codigo,
    currentContactLensesEdit.liquido.codigo,
  ]);

  useEffect(() => {
    if (actionComponent !== null) {
      setActionPopup(true);
    }
  }, [actionComponent]);

  useEffect(() => {
    if (
      CLSupplierList.length > 0 &&
      currentContactLensesEdit.datosLentillaOD.proveedor !== ""
    ) {
      const found = CLSupplierList.find((e) => {
        return e.text === currentContactLensesEdit.datosLentillaOD.proveedor;
      });
      // console.log(found);
      setSelectedRightCLSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [CLSupplierList, currentContactLensesEdit.datosLentillaOD.proveedor]);

  useEffect(() => {
    if (
      CLSupplierList.length > 0 &&
      currentContactLensesEdit.datosLentillaOI.proveedor !== ""
    ) {
      const found = CLSupplierList.find((e) => {
        return e.text === currentContactLensesEdit.datosLentillaOI.proveedor;
      });

      setSelectedLeftCLSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [CLSupplierList, currentContactLensesEdit.datosLentillaOI.proveedor]);

  useEffect(() => {
    if (
      liquidSupplierList.length > 0 &&
      currentContactLensesEdit.liquido.nombreProveedor !== ""
    ) {
      const found = liquidSupplierList.find((e) => {
        return e.text === currentContactLensesEdit.liquido.nombreProveedor;
      });
      setSelectedLiquidSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [liquidSupplierList, currentContactLensesEdit.liquido.nombreProveedor]);

  useEffect(() => {
    getCLTestHistory();
  }, [selectAll]);

  useEffect(() => {
    setTotal(calculateTotal());
  }, [
    currentContactLensesEdit.datosLentillaOD.totalPrecio,
    currentContactLensesEdit.datosLentillaOI.totalPrecio,
    currentContactLensesEdit.liquido.total,
  ]);

  return (
    <div className="popup-container">
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          onClose={() => {
            reloadACList();
            setActionPopup(false);
            setActionComponent(null);
          }}
        ></ActionPopup>
      )}
      {CLTest && (
        <ContactLensesTest
          id={selectedCLTest}
          contactLensesId={contactLensesId}
          onOpen={() => {}}
          agentList={agentList}
          patientInfo={patientInfo}
          onClose={async () => {
            setSelectedCLTest(-1);
            setCLTest(false);
            await getCLTestHistory();
          }}
          onReloadCLTest={async () => {
            await getCLTestHistory();
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        ></ContactLensesTest>
      )}
      {toggleObservationPanel && (
        <ObservationsPanel
          objectInfo={currentContactLensesEdit.idFicha}
          category="Ficha"
          onClose={async () => {
            setToggleObservationPanel(false);
            refreshObservations();
          }}
        ></ObservationsPanel>
      )}
      {reportPopup && (
        <ContactLensesReportPopup
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onExport={async (data) => {
            await printFile(data);
          }}
          onGenerateOfficialPrescription={() => {
            const emptyField = findEmptyLensGraduationField();
            if (emptyField) {
              createPopupQuestion(
                `El campo ${emptyField.fieldLabel} de la sección ${emptyField.sectionName} no puede estar vacío. Asigne un valor y guarde la ficha.`,
                () => {
                  removePopupQuestion();
                },
                null,
                "Cerrar",
              );
              return;
            }
            setCGCOOPopup(true);
          }}
          onClose={() => {
            setReportPopup(false);
          }}
        />
      )}
      <PopupCGCOOLentesContacto
        show={CGCOOPopup}
        idFichaLentillas={currentContactLensesEdit.idFichaLentillas}
        agenteFicha={currentContactLensesEdit.empleado}
        tipoLenteOD={currentContactLensesEdit.datosLentillaOD.tipo}
        tipoLenteOI={currentContactLensesEdit.datosLentillaOI.tipo}
        proveedorLenteOD={currentContactLensesEdit.datosLentillaOD.proveedor}
        proveedorLenteOI={currentContactLensesEdit.datosLentillaOI.proveedor}
        createPopupQuestion={createPopupQuestion}
        removePopupQuestion={removePopupQuestion}
        onAccept={() => {
          setCGCOOPopup(false);
        }}
        onCancel={() => {
          setCGCOOPopup(false);
        }}
      />
      <div className="popup-screen">
        <div className="popup-screen-header">
          <button
            className="popup-action-icon close-icon"
            onClick={async () => {
              if (
                !areObjectsEqual(currentContactLenses, currentContactLensesEdit)
              ) {
                createPopupQuestion(
                  "Existen cambios que no han sido guardados. ¿Desea guardar antes de salir?",
                  async () => {
                    removePopupQuestion();
                    await saveCL(onClose);
                  },
                  () => {
                    removePopupQuestion();
                    onClose();
                  },
                  "Sí",
                  "No",
                );
              } else {
                onClose();
              }
              await getCLHistory();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span className="popup-screen-header-title">
            Ficha de lentes de contacto
          </span>
        </div>
        {loadingData && (
          <LoadingScreen message="Cargando ficha de lentes de contacto..."></LoadingScreen>
        )}
        {!loadingData && (
          <div className="tab-content background-gray" style={{ padding: 0 }}>
            <div
              className="popup-screen-actions"
              style={{ gap: 10, paddingBottom: 10 }}
            >
              <div className="popup-screen-box container-panel">
                <div className="popup-screen-box-info">
                  <div className="cell-extra">
                    <span className="label">Creación</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="datetime-local"
                        max="9999-12-31T23:59"
                        step="1"
                        tabIndex={120}
                        className="input-field input-cell"
                        value={currentContactLensesEdit.fechaCreacion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            fechaCreacion: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Entrega</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="date"
                        max="9999-12-31"
                        tabIndex={121}
                        className="input-field"
                        value={currentContactLensesEdit.fechaEntrega}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            fechaEntrega: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Actualización</span>
                  </div>
                  <div className="cell-extra w-220">
                    <InputData
                      size={0}
                      input={moment(
                        currentContactLensesEdit.fechaActualizacion,
                      ).format("DD/MM/YYYY HH:mm:ss")}
                      inactive={true}
                    ></InputData>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Revisión</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="date"
                        max="9999-12-31"
                        tabIndex={122}
                        className="input-field"
                        value={currentContactLensesEdit.fechaRevision}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            fechaRevision: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">
                      Histórico ({dateHistoryList.length})
                    </span>
                  </div>
                  <div className="cell-extra w-100p">
                    <DropdownFilter
                      tabIndex={123}
                      selectedOptions={[]}
                      optionList={dateHistoryList.map((item) => ({
                        id: item.idFichaLentillas,
                        text: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
                          "DD/MM/YYYY HH:mm:ss",
                        ),
                        active: selectedDate.id === item.idFichaLentillas,
                      }))}
                      size={0}
                      op={moment(
                        selectedDate.text,
                        "YYYY-MM-DD HH:mm:ss",
                      ).format("DD/MM/YYYY HH:mm:ss")}
                      disabled={contactLensesId === -1}
                      onChange={async (e) => {
                        setLoadingData(true);
                        setCurrentContactLensesEdit(contactLensRecordStructure);
                        setSelectedDate({
                          id: e.id,
                          text: moment(e.text, "DD/MM/YYYY HH:mm:ss").format(
                            "YYYY-MM-DD HH:mm:ss",
                          ),
                        });
                        setContactLensesId(e.id);
                      }}
                    ></DropdownFilter>
                  </div>
                </div>
              </div>
              <div className="popup-screen-box container-panel">
                <ButtonIconV
                  text="Nuevo"
                  icon={
                    contactLensesId !== -1
                      ? "/images/create-blue.svg"
                      : "/images/create-gray.svg"
                  }
                  onClick={() => {
                    if (contactLensesId !== -1) {
                      if (
                        !areObjectsEqual(
                          currentContactLenses,
                          currentContactLensesEdit,
                        )
                      ) {
                        createPopupQuestion(
                          `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de crear una nueva ficha?`,
                          async () => {
                            await saveCL();
                            removePopupQuestion();
                            resetCLState();
                          },
                          async () => {
                            removePopupQuestion();
                            resetCLState();
                          },
                          "Sí",
                          "No",
                        );
                      } else {
                        resetCLState();
                      }
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Reposición"
                  icon={
                    contactLensesId !== -1
                      ? "/images/clone-blue.svg"
                      : "/images/clone-gray.svg"
                  }
                  onClick={() => {
                    if (contactLensesId !== -1) {
                      createPopupQuestion(
                        `¿Desea realizar reposición de esta ficha de lentes de contacto?`,
                        async () => {
                          await cloneCL();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Guardar"
                  icon="/images/save-blue.svg"
                  onClick={async () => {
                    await saveCL();
                    await getCLHistory();
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Cancelar"
                  icon="/images/cancel-blue.svg"
                  onClick={() => {
                    if (
                      dateHistoryList.length === 0 &&
                      areObjectsEqual(
                        currentContactLenses,
                        currentContactLensesEdit,
                      )
                    ) {
                      removePopupQuestion();
                    } else if (
                      !areObjectsEqual(
                        currentContactLenses,
                        currentContactLensesEdit,
                      ) ||
                      contactLensesId === -1
                    ) {
                      createPopupQuestion(
                        `¿Desea cancelar los cambios realizados?`,
                        async () => {
                          await cancelChanges();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Recargar"
                  icon={
                    contactLensesId !== -1
                      ? "/images/update-blue.svg"
                      : "/images/update-gray.svg"
                  }
                  onClick={() => {
                    if (contactLensesId !== -1) {
                      createPopupQuestion(
                        `¿Desea recargar esta ficha de lentes de contacto?`,
                        async () => {
                          await getContactLenses(contactLensesId);
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Eliminar"
                  icon={
                    contactLensesId !== -1
                      ? "/images/remove-blue.svg"
                      : "/images/remove-gray.svg"
                  }
                  onClick={async () => {
                    if (contactLensesId !== -1) {
                      createPopupQuestion(
                        `¿Desea eliminar esta ficha de lentes de contacto?`,
                        async () => {
                          await deleteCL();
                          await getCLHistory();
                          await selectCLAfterDeleting();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Imprimir"
                  icon={
                    contactLensesId !== -1
                      ? "/images/print-blue.svg"
                      : "/images/print-gray.svg"
                  }
                  onClick={async () => {
                    if (contactLensesId !== -1) {
                      setReportPopup(true);
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Finalizar"
                  icon={
                    contactLensesId !== -1
                      ? "/images/shopping-cart-blue.svg"
                      : "/images/shopping-cart-gray.svg"
                  }
                  onClick={() => {
                    if (contactLensesId !== -1) {
                      handleOpenActionPopup("sales");
                    } else {
                      checkSaved();
                    }
                  }}
                ></ButtonIconV>
              </div>
            </div>
            <div className="popup-screen-content">
              <div
                className="popup-screen-content-col w-70"
                style={{ gap: 10 }}
              >
                <div className="container-panel">
                  <div className="opt-table-title">
                    Datos lente de contacto OD
                  </div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={61}
                        type="type-only-numbers"
                        size={6}
                        maxLength={10}
                        input={currentContactLensesEdit.datosLentillaOD.codigo}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD:
                              contactLensRecordStructure.datosLentillaOD,
                          });
                          setSelectedRightCLSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(61);
                        }}
                        onEnter={async () => {
                          await searchCLByCode(
                            0,
                            currentContactLensesEdit.datosLentillaOD.codigo,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addRightCL");
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Tarifa"
                        small
                        onClick={() => {}}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Opciones
                    </div>
                    <div
                      className="cell"
                      style={{ justifyContent: "space-between" }}
                    >
                      <ButtonIconH
                        text="Copiar a LC izquierda"
                        small
                        onClick={() => {
                          handleRightOp(1);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Cargar optometría"
                        small
                        onClick={() => {
                          handleRightOp(2);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Cargar trasposición"
                        small
                        onClick={() => {
                          handleRightOp(3);
                        }}
                      ></ButtonIconH>
                    </div>

                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={62}
                        optionList={CLSupplierList}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOD.proveedor}
                        disabled={true}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              proveedor: e.text,
                            },
                          });

                          const supplierToSet = CLSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          );
                          setSelectedRightCLSupplier(
                            supplierToSet || { id: -1, text: "" },
                          );
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={63}
                        optionList={rightCLBrandList}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOD.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Uso
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={68}
                        optionList={contactLensesUseOptions}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOD.uso}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              uso: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Nombre comercial
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={64}
                        optionList={rightCLModelsList}
                        size={0}
                        op={
                          currentContactLensesEdit.datosLentillaOD
                            .nombreComercial
                        }
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              nombreComercial: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Desechable
                    </div>
                    <div className="cell cell-start-content">
                      <div
                        className="data-field c-pointer"
                        onClick={() => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              desechable:
                                !currentContactLensesEdit.datosLentillaOD
                                  .desechable,
                            },
                          });
                        }}
                      >
                        <CheckBox
                          tabIndex={69}
                          active={
                            currentContactLensesEdit.datosLentillaOD.desechable
                          }
                          onClick={() => {}}
                        ></CheckBox>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Tipo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={65}
                        optionList={CLTypeList}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOD.tipo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              tipo: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Color
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={66}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.color}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              color: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-7-summary">
                        <div className="cell cell-label">PVP</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">DTO %</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">Pack</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">Total</div>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Unidades
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={67}
                        type="type-integer"
                        size={0}
                        input={
                          currentContactLensesEdit.datosLentillaOD.unidades
                        }
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              unidades: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-7-summary">
                        <div className="cell">
                          <InputData
                            tabIndex={70}
                            type="type-positive-float"
                            size={6}
                            input={currentContactLensesEdit.datosLentillaOD.pvp}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurPrice(e, "datosLentillaOD", "totalPrecio")
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={71}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentContactLensesEdit.datosLentillaOD.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurDiscount(
                                e,
                                "datosLentillaOD",
                                "totalPrecio",
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={72}
                            type="type-positive-integer"
                            size={6}
                            input={
                              currentContactLensesEdit.datosLentillaOD.pack
                            }
                            onChange={(e) => {
                              setCurrentContactLensesEdit({
                                ...currentContactLensesEdit,
                                datosLentillaOD: {
                                  ...currentContactLensesEdit.datosLentillaOD,
                                  pack: e,
                                },
                              });
                            }}
                            onBlur={(e) => {
                              const inputValue = Number(e) || 1;

                              handlePackPrice(
                                "datosLentillaOD",
                                inputValue,
                                currentContactLensesEdit,
                                setCurrentContactLensesEdit,
                              );
                            }}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={73}
                            type="type-positive-float"
                            size={6}
                            input={
                              currentContactLensesEdit.datosLentillaOD
                                .totalPrecio
                            }
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(
                                e,
                                "datosLentillaOD",
                                "totalPrecio",
                                73,
                              )
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opt-table-content grid-10">
                    <div className="cell combined-cells-10"></div>
                    <div className="cell cell-label">Esf</div>
                    <div className="cell cell-label">Cil</div>
                    <div className="cell cell-label">Eje</div>
                    <div className="cell cell-label">Add</div>
                    <div className="cell cell-label">Total</div>
                    <div className="cell cell-label">Rad</div>
                    <div className="cell cell-label">Rad2</div>
                    <div className="cell cell-label">Diá</div>
                    <div className="cell cell-label">AVCC</div>
                    <div className="cell cell-label">AO</div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={74}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.esf}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              esf: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (currentContactLensesEdit.datosLentillaOD.add) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOD: {
                                ...currentContactLensesEdit.datosLentillaOD,
                                total: calculateTotalLens(
                                  currentContactLensesEdit.datosLentillaOD.esf,
                                  currentContactLensesEdit.datosLentillaOD.add,
                                ),
                              },
                            });
                          } else if (
                            currentContactLensesEdit.datosLentillaOD.total
                          ) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOD: {
                                ...currentContactLensesEdit.datosLentillaOD,
                                add: calculateAddFromTotal(
                                  currentContactLensesEdit.datosLentillaOD.esf,
                                  currentContactLensesEdit.datosLentillaOD
                                    .total,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={75}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.cil}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              cil: e,
                            },
                          });
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={76}
                        type="type-only-positive-numbers"
                        maxLength={3}
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.eje}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              eje: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={77}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.add}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              add: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            currentContactLensesEdit.datosLentillaOD.add !== ""
                          ) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOD: {
                                ...currentContactLensesEdit.datosLentillaOD,
                                total: calculateTotalLens(
                                  currentContactLensesEdit.datosLentillaOD.esf,
                                  currentContactLensesEdit.datosLentillaOD.add,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={78}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.total}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              total: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            currentContactLensesEdit.datosLentillaOD.total !==
                            ""
                          ) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOD: {
                                ...currentContactLensesEdit.datosLentillaOD,
                                add: calculateAddFromTotal(
                                  currentContactLensesEdit.datosLentillaOD.esf,
                                  currentContactLensesEdit.datosLentillaOD
                                    .total,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={79}
                        maxLength={6}
                        type="type-alphanum-ext"
                        size={0}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOD.rad}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              rad: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={80}
                        maxLength={6}
                        type="type-alphanum-ext"
                        size={0}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOD.rad2}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              rad2: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={81}
                        type="type-float2"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOD.dia}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              dia: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={82}
                        type="type-alphanum-ext"
                        size={0}
                        maxLength={9}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOD.avcc}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              avcc: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={83}
                        maxLength={9}
                        type="type-alphanum-ext"
                        size={0}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOD.ao}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOD: {
                              ...currentContactLensesEdit.datosLentillaOD,
                              ao: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                  </div>
                </div>

                <div className="container-panel">
                  <div className="opt-table-title">
                    Datos lente de contacto OI
                  </div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={84}
                        type="type-only-numbers"
                        size={6}
                        maxLength={10}
                        input={currentContactLensesEdit.datosLentillaOI.codigo}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI:
                              contactLensRecordStructure.datosLentillaOI,
                          });
                          setSelectedLeftCLSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(84);
                        }}
                        onEnter={async () => {
                          await searchCLByCode(
                            1,
                            currentContactLensesEdit.datosLentillaOI.codigo,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addLeftCL");
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Tarifa"
                        small
                        onClick={() => {}}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Opciones
                    </div>
                    <div
                      className="cell"
                      style={{ justifyContent: "space-between" }}
                    >
                      <ButtonIconH
                        text="Copiar a LC derecha"
                        small
                        onClick={() => {
                          handleLeftOp(1);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Cargar optometría"
                        small
                        onClick={() => {
                          handleLeftOp(2);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Cargar trasposición"
                        small
                        onClick={() => {
                          handleLeftOp(3);
                        }}
                      ></ButtonIconH>
                    </div>

                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={85}
                        optionList={CLSupplierList}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOI.proveedor}
                        disabled={true}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              proveedor: e.text,
                            },
                          });
                          const supplierToSet = CLSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          );
                          setSelectedLeftCLSupplier(
                            supplierToSet || {
                              id: -1,
                              text: "",
                            },
                          );
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={86}
                        optionList={leftCLBrandList}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOI.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Uso
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={91}
                        optionList={contactLensesUseOptions}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOI.uso}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              uso: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Nombre comercial
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={87}
                        optionList={leftCLModelsList}
                        size={0}
                        op={
                          currentContactLensesEdit.datosLentillaOI
                            .nombreComercial
                        }
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              nombreComercial: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Desechable
                    </div>
                    <div className="cell cell-start-content">
                      <div
                        className="data-field c-pointer"
                        onClick={() => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              desechable:
                                !currentContactLensesEdit.datosLentillaOI
                                  .desechable,
                            },
                          });
                        }}
                      >
                        <CheckBox
                          tabIndex={92}
                          active={
                            currentContactLensesEdit.datosLentillaOI.desechable
                          }
                          onClick={() => {}}
                        ></CheckBox>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Tipo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={88}
                        optionList={CLTypeList}
                        size={0}
                        op={currentContactLensesEdit.datosLentillaOI.tipo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              tipo: e.id,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Color
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={89}
                        maxLength={20}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.color}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              color: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-7-summary">
                        <div className="cell cell-label">PVP</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">DTO %</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">Pack</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">Total</div>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Unidades
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={90}
                        type="type-integer"
                        size={0}
                        input={
                          currentContactLensesEdit.datosLentillaOI.unidades
                        }
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              unidades: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-7-summary">
                        <div className="cell">
                          <InputData
                            tabIndex={93}
                            type="type-positive-float"
                            size={6}
                            input={currentContactLensesEdit.datosLentillaOI.pvp}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurPrice(e, "datosLentillaOI", "totalPrecio")
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={94}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentContactLensesEdit.datosLentillaOI.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurDiscount(
                                e,
                                "datosLentillaOI",
                                "totalPrecio",
                              )
                            }
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={95}
                            type="type-positive-integer"
                            size={6}
                            input={
                              currentContactLensesEdit.datosLentillaOI.pack
                            }
                            onChange={(e) => {
                              setCurrentContactLensesEdit({
                                ...currentContactLensesEdit,
                                datosLentillaOI: {
                                  ...currentContactLensesEdit.datosLentillaOI,
                                  pack: e,
                                },
                              });
                            }}
                            onBlur={(e) => {
                              const inputValue = Number(e) || 1;
                              handlePackPrice(
                                "datosLentillaOI",
                                inputValue,
                                currentContactLensesEdit,
                                setCurrentContactLensesEdit,
                              );
                            }}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={96}
                            type="type-positive-float"
                            size={6}
                            input={
                              currentContactLensesEdit.datosLentillaOI
                                .totalPrecio
                            }
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(
                                e,
                                "datosLentillaOI",
                                "totalPrecio",
                                96,
                              )
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="opt-table-content grid-10">
                    <div className="cell combined-cells-10"></div>
                    <div className="cell cell-label">Esf</div>
                    <div className="cell cell-label">Cil</div>
                    <div className="cell cell-label">Eje</div>
                    <div className="cell cell-label">Add</div>
                    <div className="cell cell-label">Total</div>
                    <div className="cell cell-label">Rad</div>
                    <div className="cell cell-label">Rad2</div>
                    <div className="cell cell-label">Diá</div>
                    <div className="cell cell-label">AVCC</div>
                    <div className="cell cell-label">AO</div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={97}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.esf}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              esf: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (currentContactLensesEdit.datosLentillaOI.add) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOI: {
                                ...currentContactLensesEdit.datosLentillaOI,
                                total: calculateTotalLens(
                                  currentContactLensesEdit.datosLentillaOI.esf,
                                  currentContactLensesEdit.datosLentillaOI.add,
                                ),
                              },
                            });
                          } else if (
                            currentContactLensesEdit.datosLentillaOI.total
                          ) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOI: {
                                ...currentContactLensesEdit.datosLentillaOI,
                                add: calculateAddFromTotal(
                                  currentContactLensesEdit.datosLentillaOI.esf,
                                  currentContactLensesEdit.datosLentillaOI
                                    .total,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={98}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.cil}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              cil: e,
                            },
                          });
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={99}
                        type="type-only-positive-numbers"
                        maxLength={3}
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.eje}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              eje: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputDataControl
                        tabIndex={100}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.add}
                        minValue=""
                        maxValue=""
                        step={0.25}
                        numDecimales=""
                        createPopupQuestion={createPopupQuestion}
                        removePopupQuestion={removePopupQuestion}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              add: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            currentContactLensesEdit.datosLentillaOI.add !== ""
                          ) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOI: {
                                ...currentContactLensesEdit.datosLentillaOI,
                                total: calculateTotalLens(
                                  currentContactLensesEdit.datosLentillaOI.esf,
                                  currentContactLensesEdit.datosLentillaOI.add,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputDataControl>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={101}
                        type="type-optofloat"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.total}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              total: e,
                            },
                          });
                        }}
                        onBlur={() => {
                          if (
                            currentContactLensesEdit.datosLentillaOI.total !==
                            ""
                          ) {
                            setCurrentContactLensesEdit({
                              ...currentContactLensesEdit,
                              datosLentillaOI: {
                                ...currentContactLensesEdit.datosLentillaOI,
                                add: calculateAddFromTotal(
                                  currentContactLensesEdit.datosLentillaOI.esf,
                                  currentContactLensesEdit.datosLentillaOI
                                    .total,
                                ),
                              },
                            });
                          }
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={102}
                        maxLength={6}
                        type="type-alphanum-ext"
                        size={0}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOI.rad}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              rad: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={103}
                        maxLength={6}
                        type="type-alphanum-ext"
                        size={0}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOI.rad2}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              rad2: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={104}
                        type="type-float2"
                        size={0}
                        input={currentContactLensesEdit.datosLentillaOI.dia}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              dia: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={105}
                        type="type-alphanum-ext"
                        size={0}
                        maxLength={9}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOI.avcc}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              avcc: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={106}
                        maxLength={9}
                        type="type-alphanum-ext"
                        size={0}
                        customStyle="content-center"
                        input={currentContactLensesEdit.datosLentillaOI.ao}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            datosLentillaOI: {
                              ...currentContactLensesEdit.datosLentillaOI,
                              ao: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                  </div>
                </div>

                <div className="container-panel">
                  <div className="opt-table-title">Datos líquido</div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={107}
                        type="type-only-numbers"
                        size={6}
                        maxLength={10}
                        input={currentContactLensesEdit.liquido.codigo}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            liquido: {
                              ...currentContactLensesEdit.liquido,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            liquido: contactLensRecordStructure.liquido,
                          });
                          setSelectedLiquidSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(107);
                        }}
                        onEnter={async () => {
                          await searchLiquidByCode(
                            currentContactLensesEdit.liquido.codigo,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addLiquid");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={108}
                        optionList={liquidSupplierList}
                        size={0}
                        op={currentContactLensesEdit.liquido.nombreProveedor}
                        disabled={true}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            liquido: {
                              ...currentContactLensesEdit.liquido,
                              nombreProveedor: e.text,
                            },
                          });
                          const supplierToSet = liquidSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          );
                          setSelectedLiquidSupplier(
                            supplierToSet || { id: -1, text: "" },
                          );
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={109}
                        optionList={liquidBrandList}
                        size={0}
                        op={currentContactLensesEdit.liquido.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            liquido: {
                              ...currentContactLensesEdit.liquido,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Nombre comercial
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={110}
                        optionList={liquidModelsList}
                        size={0}
                        op={currentContactLensesEdit.liquido.nombreComercial}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            liquido: {
                              ...currentContactLensesEdit.liquido,
                              nombreComercial: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-7-summary">
                        <div className="cell cell-label">PVP</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">DTO %</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">Pack</div>
                        <div className="cell"></div>
                        <div className="cell cell-label">Total</div>
                      </div>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Capacidad
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={111}
                        type="type-integer"
                        size={0}
                        input={currentContactLensesEdit.liquido.capacidad}
                        onChange={(e) => {
                          setCurrentContactLensesEdit({
                            ...currentContactLensesEdit,
                            liquido: {
                              ...currentContactLensesEdit.liquido,
                              capacidad: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-7-summary">
                        <div className="cell">
                          <InputData
                            tabIndex={112}
                            type="type-positive-float"
                            size={6}
                            input={currentContactLensesEdit.liquido.pvp}
                            onChange={() => {}}
                            onBlur={(e) => onBlurPrice(e, "liquido", "total")}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={113}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentContactLensesEdit.liquido.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) => onBlurDiscount(e, "liquido", "total")}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={114}
                            type="type-positive-integer"
                            size={6}
                            input={currentContactLensesEdit.liquido.pack}
                            onChange={(e) => {
                              setCurrentContactLensesEdit({
                                ...currentContactLensesEdit,
                                liquido: {
                                  ...currentContactLensesEdit.liquido,
                                  pack: e,
                                },
                              });
                            }}
                            onBlur={(e) => {
                              const inputValue = Number(e) || 1;
                              handlePackPrice(
                                "liquido",
                                inputValue,
                                currentContactLensesEdit,
                                setCurrentContactLensesEdit,
                              );
                            }}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell">
                          <InputData
                            tabIndex={115}
                            type="type-positive-float"
                            size={6}
                            input={currentContactLensesEdit.liquido.total}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(e, "liquido", "total", 115)
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="popup-screen-content-col w-30 container-panel full-height"
                style={{ gap: "20px" }}
              >
                <div className="opt-table-content grid-8">
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Agente (*)
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={116}
                      optionList={agentList}
                      size={0}
                      op={currentContactLensesEdit.empleado}
                      mandatory={false}
                      onChange={(e) => {
                        setCurrentContactLensesEdit({
                          ...currentContactLensesEdit,
                          empleado: e.text,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Tipo ficha (*)
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={117}
                      optionList={recordTypeList}
                      size={0}
                      op={currentContactLensesEdit.tipoFicha}
                      mandatory={true}
                      onChange={(e) => {
                        setCurrentContactLensesEdit({
                          ...currentContactLensesEdit,
                          tipoFicha: e.id,
                        });
                      }}
                    ></Dropdown>
                  </div>
                  <div className="cell cell-label combined-cells-2 cell-start-content">
                    Motivo
                  </div>
                  <div className="cell cell-label combined-cells-6 cell-start-content">
                    <Dropdown
                      tabIndex={118}
                      optionList={reasonList}
                      size={0}
                      op={currentContactLensesEdit.motivoAgente}
                      mandatory={false}
                      onChange={(e) => {
                        setCurrentContactLensesEdit({
                          ...currentContactLensesEdit,
                          motivoAgente: e.id,
                        });
                      }}
                    ></Dropdown>
                  </div>
                </div>
                <SummarySectionBox
                  name="Observaciones"
                  numElements={observations.length}
                  onOpen={() => {
                    if (contactLensesId !== -1) {
                      setToggleObservationPanel(true);
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Nueva prueba"
                  active={CLTestList.length > 0}
                  onOpen={() => {
                    if (contactLensesId !== -1) {
                      setSelectedCLTest(-1);
                      setCLTest(true);
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Seguro"
                  active={
                    Object.keys(insurance).length > 0 &&
                    insurance.tipoSeguro !== "N"
                  }
                  onOpen={() => {
                    if (contactLensesId !== -1) {
                      handleOpenActionPopup("insurance");
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <SummarySectionBox
                  name="Datos sanitarios"
                  numElements={healthData.length}
                  onOpen={() => {
                    if (contactLensesId !== -1) {
                      handleOpenActionPopup("healthData");
                    } else {
                      checkSaved();
                    }
                  }}
                ></SummarySectionBox>
                <div className="total-summary-content">
                  <div className="total-summary-info">
                    <div className="cell cell-label cell-start-content">
                      TOTAL
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={119}
                        type="type-positive-float"
                        size={6}
                        input={total}
                        onChange={() => {}}
                        onBlur={async (e) => {
                          const value = parseFloat(e);
                          if (isNaN(value) || value === roundPrice(total)) {
                            return;
                          }
                          await updateDiscounts(value);
                        }}
                      ></InputData>
                      €
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-panel" style={{ marginTop: 10 }}>
              <div className="opt-table-title">
                Listado de pruebas ({formatValueUnit(CLTestList.length / 2)})
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  className="data-field"
                  onClick={() => {
                    setSelectAll(!selectAll);
                  }}
                >
                  <span className="label">Pruebas ficha LC</span>
                  <RadioButton
                    active={!selectAll}
                    onClick={() => {}}
                  ></RadioButton>
                </div>
                <div
                  className="data-field"
                  onClick={() => {
                    setSelectAll(!selectAll);
                  }}
                >
                  <span className="label">Pruebas paciente</span>
                  <RadioButton
                    active={selectAll}
                    onClick={() => {}}
                  ></RadioButton>
                </div>
              </div>
              <div
                className="opt-table-content grid-5"
                id="glasses-content-grid"
                style={{ marginTop: 10 }}
              >
                <div className="cell combined-cells-5">
                  <DataTable
                    columns={contactLensesTestListColumns}
                    data={CLTestList}
                    className="custom-datatable even-marked"
                    noDataComponent="No hay pruebas disponibles."
                    onRowClicked={(row, event) => {
                      setSelectedCLTest(row.idFichaLentillasPruebas);
                      setCLTest(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
